import { useGetReactions } from "../Controllers/Tribe/TribePostController";

/**
 * Hook to get available reactions
 * Fetches reactions on mount and caches them
 */
export const useReactions = () => {
  const { data: reactions = [], isLoading, error } = useGetReactions();

  return {
    reactions,
    isLoading,
    error,
    isReady: !isLoading && !error && reactions.length > 0,
  };
};

export default useReactions;
